/* ============================================
 * COLLECTION-PAGE CUSTOM BEHAVIOR
 * Split out of custom-override.js (2026-08) so other pages
 * don't ship it. Loaded from theme.liquid only when
 * template contains 'collection'.
 * ============================================ */

  // Hide redundant Product Type / Brand filters on matching collection pages
  document.addEventListener('DOMContentLoaded', function() {
    // Function to hide filters
    function hideFilters() {
      // Get all filter groups
      const filterGroups = document.querySelectorAll('.filter-group');
      
      // Get the collection handle from the URL, ignoring any query parameters
      const collectionHandle = window.location.pathname.split('/').pop().split('?')[0];
  
  
      // Iterate through all filter groups
      filterGroups.forEach((filterGroup, index) => {
        const filterName = filterGroup.querySelector('.filter-group__heading__text');
  
        if (filterName) {
          const originalFilterName = filterName.textContent.trim();
  
          // Check if this is the "Product Type" or "Brand" filter
          if (originalFilterName.toLowerCase() === 'product type' || originalFilterName.toLowerCase() === 'brand') {
            const filterItems = filterGroup.querySelectorAll('.filter-group__item__text');
            
            let matchFound = false;
            filterItems.forEach(item => {
              const itemName = item.textContent.trim();
              const processedItemName = itemName.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
              const processedItemNamePlural = processedItemName + 's';
              
  
              if (processedItemName === collectionHandle || processedItemNamePlural === collectionHandle) {
                filterGroup.style.display = 'none';
                matchFound = true;
                return;
              }
            });
  
          }
        }
      });
    }
    // Run the filter function once after DOM content is loaded
    hideFilters();
  
    // Attach a MutationObserver to the filter container to rerun the filter function when content changes
    const filterContainer = document.querySelector('.collection-filters');
    if (filterContainer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            hideFilters();
          }
        });
      });
      observer.observe(filterContainer, { childList: true, subtree: true });
    }
  
    // Check for URL changes
    let lastUrl = location.href; 
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        hideFilters();
      }
    }).observe(document, {subtree: true, childList: true});
  
    // Optionally, you can also attach an event listener to the filter inputs
    document.addEventListener('change', function(event) {
      if (event.target.closest('.collection-filters')) {
        setTimeout(hideFilters, 100); // Small delay to ensure DOM has updated
      }
    });
  });

  /* ============================================
   * SMART STICKY FILTERS
   * ============================================
   * When user scrolls and the BOTTOM of .filters reaches 
   * the bottom of the header (.logo-area), collapse and make sticky.
   * Expands when scrolling back up.
   * Only active on desktop (1000px+).
   */
  document.addEventListener('DOMContentLoaded', function() {
    // Only run on collection pages
    if (!document.body.classList.contains('template-collection')) return;
    
    const filtersEl = document.querySelector('.filter-container--side .filters');
    const filtersInner = document.querySelector('.filters__inner');
    const logoArea = document.querySelector('.logo-area');
    
    if (!filtersEl || !filtersInner) return;
    
    let isCollapsed = false;
    let initialFiltersBottom = null; // The original bottom of filters (document-relative)
    let triggerScrollPosition = null; // The scroll position that triggers collapse
    let ticking = false;
    
    // Get the sticky threshold (bottom of header area)
    function getStickyThreshold() {
      // Use the sticky header height CSS variable, plus some padding
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height') || '0');
      return headerHeight + 50; // 50px padding below header
    }
    
    // Calculate trigger point - when filters INNER bottom would reach the sticky threshold
    function captureInitialPosition() {
      if (isCollapsed) return;
      
      // Use filtersInner (the actual content) not filtersEl (the container that stretches full height)
      const filtersInnerRect = filtersInner.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const stickyThreshold = getStickyThreshold();
      
      // Store the absolute document position of the filters INNER BOTTOM
      initialFiltersBottom = scrollTop + filtersInnerRect.bottom;
      
      // Calculate when to trigger: when scrolling causes filters inner bottom to reach sticky threshold
      // filtersInnerRect.bottom (viewport) = initialFiltersBottom - scrollTop
      // We want: initialFiltersBottom - scrollTop <= stickyThreshold
      // So: scrollTop >= initialFiltersBottom - stickyThreshold
      triggerScrollPosition = initialFiltersBottom - stickyThreshold;
      
    }
    
    // Get all filter group headings and their targets
    function getFilterGroups() {
      return filtersInner.querySelectorAll('.filter-group:not(.filter-group--applied):not(.filter-group--availability)');
    }
    
    // Collapse all filter groups with animation
    function collapseFilters() {
      if (isCollapsed) return;
      isCollapsed = true;
      
      const filterGroups = getFilterGroups();
      
      // Add sticky classes and collapse filters first
      filtersEl.classList.add('smart-sticky-active', 'smart-sticky-collapsed');
      
      // Collapse each filter group instantly
      filterGroups.forEach(group => {
        const heading = group.querySelector('.filter-group__heading');
        const target = group.querySelector('.toggle-target');
        
        if (!heading || !target) return;
        
        // Skip if already hidden by user (preserve their choice)
        if (heading.classList.contains('toggle-target-toggler--is-hidden')) {
          heading.setAttribute('data-smart-sticky-was-hidden', 'true');
          return;
        }
        
        // Mark as collapsed by smart sticky
        heading.setAttribute('data-smart-sticky-collapsed', 'true');
        
        // Instant collapse
        target.style.height = '0px';
        target.style.opacity = '0';
        heading.classList.add('toggle-target-toggler--is-hidden');
      });
      
      // Start from high above and invisible
      filtersInner.style.transition = 'none';
      filtersInner.style.opacity = '0';
      filtersInner.style.transform = 'translateY(-150px)';
      
      // Force reflow
      filtersInner.offsetHeight;
      
      // Restore transition and animate down into view
      filtersInner.style.transition = '';
      requestAnimationFrame(() => {
        filtersInner.style.opacity = '1';
        filtersInner.style.transform = 'translateY(0)';
      });
    }
    
    // Expand all filter groups with animation
    function expandFilters() {
      if (!isCollapsed) return;
      isCollapsed = false;
      
      const filterGroups = getFilterGroups();
      
      // Remove sticky classes and expand filters
      filtersEl.classList.remove('smart-sticky-active', 'smart-sticky-collapsed');
      
      // Expand each filter group
      filterGroups.forEach(group => {
        const heading = group.querySelector('.filter-group__heading');
        const target = group.querySelector('.toggle-target');
        const container = target ? target.querySelector('.toggle-target-container') : null;
        
        if (!heading || !target) return;
        
        // Skip if it was already hidden before smart sticky collapsed it
        if (heading.hasAttribute('data-smart-sticky-was-hidden')) {
          heading.removeAttribute('data-smart-sticky-was-hidden');
          return;
        }
        
        // Only expand if we collapsed it (still has the attribute)
        if (!heading.hasAttribute('data-smart-sticky-collapsed')) return;
        heading.removeAttribute('data-smart-sticky-collapsed');
        
        // Get target height
        const targetHeight = container ? container.scrollHeight : target.scrollHeight;
        
        // Set to expanded
        target.style.height = targetHeight + 'px';
        target.style.opacity = '1';
        heading.classList.remove('toggle-target-toggler--is-hidden');
        
        // Clean up inline styles after animation
        setTimeout(() => {
          target.style.height = '';
          target.style.opacity = '';
        }, 600);
      });
      
      // Start from high above and invisible
      filtersInner.style.transition = 'none';
      filtersInner.style.opacity = '0';
      filtersInner.style.transform = 'translateY(-150px)';
      
      // Force reflow
      filtersInner.offsetHeight;
      
      // Restore transition and animate down into view
      filtersInner.style.transition = '';
      requestAnimationFrame(() => {
        filtersInner.style.opacity = '1';
        filtersInner.style.transform = 'translateY(0)';
      });
      
      // Recapture position after expansion settles
      setTimeout(captureInitialPosition, 600);
    }
    
    // Handle manual clicks on filter headings while in sticky mode
    // This allows users to expand individual filters even when collapsed
    function setupManualToggleHandlers() {
      // Use capture phase to run BEFORE the theme's handler
      filtersInner.addEventListener('click', function(e) {
        const heading = e.target.closest('.filter-group__heading');
        if (!heading || !isCollapsed) return;
        
        // If user clicks a heading that we collapsed, we need to manually expand it
        if (heading.hasAttribute('data-smart-sticky-collapsed')) {
          // Prevent the theme's toggle from running (it would get confused)
          e.stopPropagation();
          e.preventDefault();
          
          // Remove our collapse marker
          heading.removeAttribute('data-smart-sticky-collapsed');
          
          // Get the target element
          const target = heading.nextElementSibling;
          if (!target || !target.classList.contains('toggle-target')) return;
          
          const container = target.querySelector('.toggle-target-container');
          const targetHeight = container ? container.scrollHeight : target.scrollHeight;
          
          // Remove the hidden class from heading
          heading.classList.remove('toggle-target-toggler--is-hidden');
          
          // Animate open
          target.style.height = '0px';
          target.style.opacity = '0';
          
          requestAnimationFrame(() => {
            target.style.transition = 'height 0.35s ease, opacity 0.25s ease';
            target.style.height = targetHeight + 'px';
            target.style.opacity = '1';
            
            // Clean up after animation
            setTimeout(() => {
              target.style.height = '';
              target.style.opacity = '';
              target.style.transition = '';
            }, 350);
          });
        }
      }, true); // true = capture phase
    }
    
    // Handle scroll
    function onScroll() {
      if (window.innerWidth < 1000) return;
      if (triggerScrollPosition === null) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (!isCollapsed) {
        // Collapse when we've scrolled past the trigger point
        if (scrollTop >= triggerScrollPosition) {
          collapseFilters();
        }
      } else {
        // Expand when scrolling back up past the trigger point (with buffer)
        if (scrollTop < triggerScrollPosition - 100) {
          expandFilters();
        }
      }
    }
    
    // Throttled scroll handler
    function handleScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    // Initialize
    // Wait a bit for the page to fully render and all filters to load
    setTimeout(() => {
      // Only initialize if we're on desktop
      if (window.innerWidth < 1000) return;
      
      captureInitialPosition();
      setupManualToggleHandlers();
      window.addEventListener('scroll', handleScroll, { passive: true });
      
      // Watch for filter area height changes (when user opens/closes filters)
      // This recalculates the trigger position so it stays accurate
      if (typeof ResizeObserver !== 'undefined') {
        let resizeDebounce;
        const resizeObserver = new ResizeObserver(() => {
          // Don't recalculate while collapsed (we control the height then)
          if (isCollapsed) return;
          
          // Debounce to avoid excessive recalculations
          clearTimeout(resizeDebounce);
          resizeDebounce = setTimeout(() => {
            captureInitialPosition();
          }, 100);
        });
        resizeObserver.observe(filtersInner);
      }
      
      // Handle window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (window.innerWidth < 1000 && isCollapsed) {
            // Force expand on mobile
            filtersEl.classList.remove('smart-sticky-active', 'smart-sticky-collapsed');
            isCollapsed = false;
          } else if (window.innerWidth >= 1000) {
            captureInitialPosition();
          }
        }, 150);
      }, { passive: true });
      
      // Initial check in case page loaded scrolled
      onScroll();
    }, 500);
  });

  // ==========================================================================
  // BENTO GRID — Subtle gray fill for interior empty cells
  // ==========================================================================
  window.addEventListener('load', function() {
    var grid = document.querySelector('.template-suffix-brand .product-grid');
    if (!grid || window.innerWidth < 768) return;

    var cols = 4;
    var gridRect = grid.getBoundingClientRect();
    var colWidth = gridRect.width / cols;

    var rowTopSet = {};
    var items = [];

    Array.from(grid.children).forEach(function(el) {
      if (el.classList.contains('bento-filler') || el.offsetHeight === 0) return;
      var rect = el.getBoundingClientRect();
      var top = Math.round(rect.top);
      var bottom = Math.round(rect.bottom);
      rowTopSet[top] = true;
      items.push({ top: top, bottom: bottom, left: rect.left - gridRect.left, right: rect.right - gridRect.left });
    });

    var rowTops = Object.keys(rowTopSet).map(Number).sort(function(a, b) { return a - b; });
    if (rowTops.length === 0) return;

    var occupied = new Set();
    items.forEach(function(item) {
      var startCol = Math.floor(item.left / colWidth);
      var endCol = Math.round(item.right / colWidth);
      for (var ri = 0; ri < rowTops.length; ri++) {
        if (rowTops[ri] >= item.top && rowTops[ri] < item.bottom) {
          for (var c = startCol; c < endCol; c++) {
            occupied.add(ri + ',' + c);
          }
        }
      }
    });

    // Find empty cells that have an occupied cell to their right (interior gaps)
    for (var ri = 0; ri < rowTops.length; ri++) {
      for (var c = 0; c < cols; c++) {
        if (occupied.has(ri + ',' + c)) continue;

        var hasRight = false;
        for (var cr = c + 1; cr < cols; cr++) {
          if (occupied.has(ri + ',' + cr)) { hasRight = true; break; }
        }
        if (!hasRight) continue;

        var filler = document.createElement('div');
        filler.style.gridRow = (ri + 1);
        filler.style.gridColumn = (c + 1);
        filler.className = 'bento-interior-filler';
        filler.setAttribute('aria-hidden', 'true');
        grid.appendChild(filler);
      }
    }

    // Remove bottom border from items in the last row
    var maxBottom = 0;
    items.forEach(function(item) { maxBottom = Math.max(maxBottom, item.bottom); });

    Array.from(grid.children).forEach(function(el) {
      if (el.classList.contains('bento-filler') || el.offsetHeight === 0) return;
      var rect = el.getBoundingClientRect();
      if (Math.round(rect.bottom) === maxBottom) {
        el.style.borderBottom = 'none';
      }
    });
  });
